import { render, staticRenderFns } from "./AdminFieldsBlock.vue?vue&type=template&id=0e8774b6&scoped=true"
import script from "./AdminFieldsBlock.vue?vue&type=script&lang=js"
export * from "./AdminFieldsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8774b6",
  null
  
)

export default component.exports